import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from "react-sidebar";
import '../css/App.css';


class Sidenav extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            style: "menu",
            menuStatus: "open",
            status: false,
            sidebarOpen: false

        };
        this.handleClick = this.handleClick.bind(this);
        this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    }
    onSetSidebarOpen(open) {
        this.setState({ sidebarOpen: open });
    }
    handleClick() {
        switch (this.state.menuStatus) {
            case "open":
                this.setState({
                    menuStatus: "close",
                    style: "menu active",
                    status: true
                });
                break;
            case "close":
                this.setState({
                    menuStatus: "open",
                    style: "menu",
                    status: false
                });
                break;
            default:
                break;
        }
    }
    render() {
        
        const navLinks = [
            { url: '/myaccount', name: 'My Account',icon:  <i class=" material-icons" style={{float:'left',paddingRight:20,marginLeft:-30}}>person</i> },
            { url: '/changepassword', name: 'Change Password',icon:  <i class=" material-icons"style={{float:'left',paddingRight:20,marginLeft:-30}} >https</i> },
            { url: '/privacy', name: 'Privacy Policy',icon:  <i class=" material-icons" style={{float:'left',paddingRight:20,marginLeft:-30}}>insert_drive_file</i>},
            { url: '/about', name: 'About Us',icon:  <i class=" material-icons" style={{float:'left',paddingRight:20,marginLeft:-30}}>info</i>},
            { url: '/logout', name: 'Logout',icon: <i class=" material-icons" style={{float:'left',paddingRight:20,marginLeft:-30}}>power_settings_new </i> },

        ];
        if (this.props.type === "main") {
            console.log(this.props)
            return (
                
                <div>
                    
                    <Sidebar
                    
                        sidebar={<ul style={{marginTop:'50px',paddingLeft:'30px'}}>
                            <img src={require('../images/LOGO.png')}  className="responsive-img" style={{ height: 70 }} />
                            {navLinks.map(({ url, name,icon }, i) => (
                                <li style={{marginTop:'30px'}} key={i}>
                                    <Link to={url}> {icon} {name}</Link>
                                </li>
                            ))}
                            
                     </ul>
                        }
                        
                        open={this.state.sidebarOpen}
                        onSetOpen={this.onSetSidebarOpen}
                        sidebarClassName={'menu'}
                        styles={{ sidebar: { background: "white", zIndex: 3 } }}
                        overlayClassName={'overclass'}
                    />


                    <nav className="navbar navbar-top navbar-expand navbar-dark  border-bottom" style={{
                        position: 'fixed',
                        left: 0,
                        right: 0,
                        top: 0,
                        zIndex: 1
                    }}>
                        <div className="container pad_z">
                            <div className="collapse navbar-collapse" id="navbarSupportedContent">


                                <div className="col-3 pad_z ">



                                    <i className="material-icons" onClick={() => this.onSetSidebarOpen(true)} >menu</i>

                                </div>
                                <div className="col-6 text-center"> <img src={require('../images/LOGO.png')} alt="az_logo" className="responsive-img" style={{ height: 60 }} /></div>
                                <div className="col-3 text-right  vertical-align justify-content-end pad_z">
                                    {/* <i className="material-icons" onClick={() => this.props.push.push('/search')} style={{ paddingRight: 10 }}>
                                        search
                            </i> */}
                            <i onClick={() => this.props.push.push('/notification')} className="material-icons">notifications_none</i>
                           {this.props.notification ? <i className="fa fa-circle text-danger Blink"></i> : ''} </div>

                            </div>
                        </div>
                    </nav>
                    <div style={{ height: 82 }}></div>
                </div>

            );
        }
        else if (this.props.type === "second") {
            return (
                <div>
                    <nav className="navbar navbar-top navbar-expand navbar-dark  border-bottom" style={{
                        position: 'fixed',
                        left: 0,
                        right: 0,
                        top: 0,
                        zIndex: 1
                    }}>
                        <div className="container pad_z">
                            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                <div className="col-3 pad_z ">
                                    {this.props.url === 'back' ? <i onClick={() => this.props.Push.goBack()} className="material-icons back-btn grey-text">arrow_back</i> : <Link to={this.props.url}><i className="material-icons back-btn grey-text">arrow_back</i></Link>}

                                </div>
                                <div className="col-6 text-center"> <img src={require('../images/LOGO.png')} alt="az_logo" className="responsive-img" style={{ height: 60 }} /></div>
                                <div className="col-3 text-right  vertical-align justify-content-end pad_z"></div>

                            </div>
                        </div>
                    </nav>
                    <div style={{ height: 82 }}></div>
                </div>
            );
        }
    }
}

export default Sidenav;